import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: '',
  userRole: 'user', // Add userRole state to manage user role
};

const dashboardTypeSlice = createSlice({
  name: 'dashboardType',
  initialState,
  reducers: {
    // Action to toggle user role
    toggleUserRole: (state) => {
      state.userRole = state.userRole === 'user' ? 'HR' : 'user';
    },
    // Action to set user role to a specific value
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Modify extraReducers accordingly if needed
  },
});

export const { toggleUserRole, setUserRole } = dashboardTypeSlice.actions;

// Selector function to get user role
export const selectUserRole = (state) => state.dashboardType.userRole;


export default dashboardTypeSlice.reducer;
